import {
  takeEvery, put, call, select,
} from 'redux-saga/effects';
import * as types from '../types';
import { ConfigService } from '../../services';
import { waitFor } from './general';

function* loadConfig(action) {
  try {
    yield call(waitFor, state => state.token != null);
    const { token } = yield select((state) => state);
    const configService = yield call(() => new ConfigService(token));

    const config = yield call([
      configService,
      configService.getConfig,
    ]);

    yield put({
      type: types.SET_CONFIG,
      payload: config.result,
    });

  } catch (error) {
    console.error('fetchConfig error', error);
  }
}

export function* configSagas() {
  yield takeEvery(types.LOAD_CONFIG, loadConfig);
}

export default configSagas;
